<template>
  <div v-if="hasAttributes" class="pdp-product-attributes-container">
    <component
      :is="getAttributeComponent(attributes)"
      :base-properties="baseProperties"
      :product="product"
      :init-attribute-selection="initAttributeSelection"
      :render-stock-status="renderStockStatus"
      :stock-message="stockMessage"
      :is-loading-stock-data="isLoadingStockData"
      :label="getAttributeLabel(attributes)"
      :attribute="attributes"
      @product-selected="productSelected"
      @color-changed="
        (color) => {
          $emit('color-changed', color);
        }
      "
    >
    </component>
  </div>
</template>
<script>
import {AttributeRenderer} from '@/components/containers/pdp/attributes/mixins/attribute-renderer';

export default {
  name: 'PdpProductAttributesContainer',
  mixins: [AttributeRenderer],
  props: {
    product: {
      type: Object,
      required: true,
    },
    initAttributeSelection: {
      type: Object,
      default: () => {},
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasAttributes() {
      return this.product && this.attributes && this.attributes.length > 0;
    },
    attributes() {
      return this.product.categorizationHierarchyValues;
    },
  },
  methods: {
    productSelected(options) {
      this.$emit('input', options.productCode);
    },
  },
};
</script>
